/**
 * FileName : news.ts
 * ProjectName : admin
 * Author : terrorblade
 * Created Date: 2021-07-07 16:37:54
 * Description :
 * -----
 * Last Modified: 2024-12-09 09:23:16
 * Modified By :
 * -----
 * Copyright (c) 2021 Magina Corporation. All rights reserved.
 */

import {MAX_EVENT_COUNT} from 'src/utils/const';
const initState = {
    newsShow: false,
    newsCount: 0,
    newsList: [],
};

export type NEWSITEM = {
    TITLE: string;
    EVENT_DESC: string;
    EVENT_ID: string;
    ALARM_TYPE: string;
    DEVICE_ADDRESS: string;
    DEVICE_NO: string;
    OCCUR_DATETIME: string;
    dataStatus: string;
    TYPE:'Event'|'Data',
    SN: string;
}

export type INITSTATE = {
    newsShow: boolean;
    newsCount: number;
    newsList: NEWSITEM[];
}

export type ACTION = {
    type: string
    value: boolean
}

export type NEWS_LIST_ACTION = {
    type: string;
    value: NEWSITEM|null|NEWSITEM[];
}

export type NEWS_COUNT_ACTION = {
    type: string;
    value: number;
}

export const NEW_TOGGLE = 'new_toggle'; // 消息列表的展示与隐藏

export const NEWS_ADD = 'news_add'; // 添加消息

export const NEWS_REPLACE = 'news_replace'; // 替换消息列表

export const NEWS_CLEAR = 'news_clear'; // 清除消息

export const NEWS_COUNT_ADD = 'news_count_add'; // 增加数量

export const NEWS_COUNT_CLEAR = 'news_count_clear'; // 清零

/**
   * 右边消息的显示与隐藏；newShow为true时，显示，否则隐藏
   * @param {initState} state state
   * @param {ACTION} action action
   * @returns {state} state
   */
export const toggleNews = (state: INITSTATE = initState, action: ACTION) => {
    switch (action.type) {
        case NEW_TOGGLE:
            return {...state, newsShow: action.value};
        default:
            return state;
    }
};

export const newsDispose = (state: INITSTATE = initState, action: NEWS_LIST_ACTION) => {
    switch (action.type) {
        case NEWS_ADD:
            // eslint-disable-next-line no-case-declarations
            const value = action.value as NEWSITEM;
            // eslint-disable-next-line no-case-declarations
            const list = [ ...state.newsList ];

            if (list.length >= MAX_EVENT_COUNT) {
                list.pop();
            }

            list.unshift(value);
            return { ...state, newsList: list };
        case NEWS_CLEAR:
            return { ...state, newsList: [], newsCount: 0 };
        case NEWS_REPLACE:
            return {...state, newsList: action.value };
        default:
            return state;
    }
};

export const newsCountDispath = (state: INITSTATE = initState, action:NEWS_COUNT_ACTION) => {
    switch (action.type) {
        case NEWS_COUNT_ADD:
            return { ...state, newsCount: action.value };
        case NEWS_COUNT_CLEAR:
            return { ...state, newsCount: 0 };
        default:
            return state;
    }
};
